import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-343c5068"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 0,
  class: "hidden-sm-and-down"
}
const _hoisted_3 = {
  key: 1,
  class: "hidden-md-and-up"
}
const _hoisted_4 = {
  key: 0,
  class: "cookie-banner"
}
const _hoisted_5 = { class: "cookie-banner__container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-center" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "cookie-banner__title" }, " Ce site utilise des cookies")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-center ml-md-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "cookie-banner__description" }, " Ce site utilise des cookies essentiels uniquement à des fins techniques, garantissant le bon fonctionnement de ses services. Aucune donnée à caractère personnel n'est collectée à des fins publicitaires ou de suivi. En poursuivant votre navigation sur ce site, vous consentez à l'utilisation de ces cookies techniques. ")
], -1))
const _hoisted_8 = { class: "d-flex align-center ml-md-8 justify-md-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_bp_footer = _resolveComponent("bp-footer")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_app_bar, null, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                class: "ml-4",
                src: require('@/assets/logo.png'),
                height: "30",
                alt: "icon"
              }, null, 8, _hoisted_1),
              _createVNode(_component_v_app_bar_title, null, {
                default: _withCtx(() => [
                  _createElementVNode("h2", {
                    "aria-level": "1",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.redirectHome && _ctx.redirectHome(...args))),
                    class: "app-brand"
                  }, " BroPoll ")
                ]),
                _: 1
              }),
              _createVNode(_component_v_spacer, { class: "hidden-sm-and-down" }),
              (_ctx.isConnected)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_v_btn, {
                      "prepend-icon": "mdi-account-edit",
                      onClick: _ctx.redirectMyPolls
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Mes sondages")
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_v_btn, {
                      "prepend-icon": "mdi-poll",
                      onClick: _ctx.redirectMyContributions
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Mes contributions")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isConnected)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_v_btn, {
                      icon: "mdi-account-edit",
                      onClick: _ctx.redirectMyPolls
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_v_btn, {
                      icon: "mdi-poll",
                      onClick: _ctx.redirectMyContributions
                    }, null, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isConnected)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 2,
                    class: "mr-8",
                    color: "grey-darken-4",
                    variant: "flat",
                    onClick: _ctx.redirectLogin,
                    icon: "",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-account")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : (_openBlock(), _createBlock(_component_v_btn, {
                    key: 3,
                    class: "mr-8",
                    color: "grey-darken-4",
                    variant: "flat",
                    onClick: _ctx.logout,
                    icon: "",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-logout")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
            ]),
            _: 1
          }),
          _createVNode(_component_router_view),
          _createVNode(_component_bp_footer)
        ]),
        _: 1
      }),
      (!_ctx.hasAcceptedCookie)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_v_btn, {
                  icon: "mdi-close",
                  onClick: _ctx.acceptCookie,
                  color: "black",
                  class: "mx-4 white--text"
                }, null, 8, ["onClick"])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}